export enum CenterOpenState {
    OPENING_CHECKLIST = "opening_checklist",
    OPEN = "open",
    CLOSING = "closing",
    CAN_BE_CLOSED = "can_be_closed",
    CLOSING_CHECKLIST = "closing_checklist",
    CLOSED = "closed",
}